import { Button, FlosIcon, Link, ModalDialog, ModalOverlay, Table } from '@flos/react-ui';
import { useState } from 'react';
import DOMPurify from 'dompurify';
import { useHippoText } from '../../../hooks/useHippoText';

const CoveragePackageModalLink = ({
    modalName,
    title,
    description,
    included = [],
    excluded = []
}: {
    modalName: string;
    title: string;
    description: string;
    included?: string[];
    excluded?: string[];
}): React.JSX.Element => {
    const [showModal, setShowModal] = useState(false);
    const getHippoText = useHippoText();

    return (
        <>
            <Link
                className="u-color-primary-2-base"
                onClick={() => {
                    setShowModal(true);
                }}
            >
                {modalName}
            </Link>
            {showModal && (
                <ModalOverlay
                    isOpen={showModal}
                    onDismiss={() => {
                        setShowModal(false);
                    }}
                >
                    <ModalDialog
                        closeIconHandler={() => {
                            setShowModal(false);
                        }}
                    >
                        <div className="u-spacing-inset-l">
                            <div className="u-spacing-inset-l--stretch-max">
                                <h4 className="u-spacing-stack-sm">
                                    {DOMPurify.sanitize(getHippoText(title))}
                                </h4>
                                <p
                                    className="u-spacing-stack-sm"
                                    dangerouslySetInnerHTML={{
                                        __html: DOMPurify.sanitize(getHippoText(description))
                                    }}
                                />
                                {(included.length > 0 || excluded.length > 0) && (
                                    <Table className="u-spacing-inset-l--stretch-max">
                                        <Table.Head>
                                            <Table.Row>
                                                <Table.HeadCell>Dækker</Table.HeadCell>
                                                <Table.HeadCell>Dækker Ikke</Table.HeadCell>
                                            </Table.Row>
                                        </Table.Head>
                                        <Table.Body>
                                            {Array.from({
                                                length: Math.max(included.length, excluded.length)
                                            }).map((_, index) => (
                                                <Table.Row key={index}>
                                                    <Table.Cell className="u-whitespace-pre-wrap">
                                                        <div className="u-display-flex u-flex-row u-flex-items-center u-flex-justify-between u-gap-5">
                                                            <div>{included[index] || ''}</div>
                                                            {included[index] && (
                                                                <div>
                                                                    <FlosIcon
                                                                        size="medium"
                                                                        shape="circle-check"
                                                                        className="has-fill is-green"
                                                                    />
                                                                </div>
                                                            )}
                                                        </div>
                                                    </Table.Cell>
                                                    <Table.Cell className="u-whitespace-pre-wrap">
                                                        {excluded[index] && (
                                                            <div
                                                                className="u-display-flex u-flex-row u-flex-items-center
                                                                            u-flex-justify-between u-gap-5"
                                                            >
                                                                <div>{excluded[index]}</div>
                                                                <div>
                                                                    <FlosIcon
                                                                        size="medium"
                                                                        shape="circle-close"
                                                                        className="has-fill is-grey"
                                                                    />
                                                                </div>
                                                            </div>
                                                        )}
                                                    </Table.Cell>
                                                </Table.Row>
                                            ))}
                                        </Table.Body>
                                    </Table>
                                )}
                            </div>
                            <Button
                                onClick={() => {
                                    setShowModal(false);
                                }}
                            >
                                {getHippoText('DSS-COMMON-CLOSE')}
                            </Button>
                        </div>
                    </ModalDialog>
                </ModalOverlay>
            )}
        </>
    );
};

export default CoveragePackageModalLink;
